"use client";

import { useRef } from "react";
import type { StepProps } from "./types";
import useIsIntersecting from "~/lib/hooks/is-intersecting";
import Step from ".";
import { cn } from "~/lib/utils";

export default function AnimatedStep(props: StepProps) {
  const ref = useRef<HTMLDivElement>(null);

  const isIntersecting = useIsIntersecting({
    ref,
    intersectionObserverInit: {
      threshold: 0.25,
    },
  });

  return (
    <Step
      {...props}
      ref={ref}
      className={cn(
        "transition-opacity duration-700 ease-in-out delay-300",
        isIntersecting ? "opacity-100" : "opacity-0",
      )}
    />
  );
}
